// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3HNVt","title":"Header_title__J0ArA","side":"Header_side__17fzh"};